var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTableOpen = function SvgTableOpen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 19,
    viewBox: "0 0 18.6 17.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 .75A.75.75 0 0 1 .75 0h17a.75.75 0 0 1 0 1.5h-17A.75.75 0 0 1 0 .75m0 8A.75.75 0 0 1 .75 8h17a.75.75 0 0 1 0 1.5h-17A.75.75 0 0 1 0 8.75M.75 16a.75.75 0 0 0 0 1.5h17a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTableOpen);
export default ForwardRef;